import { render, staticRenderFns } from "./RememberSection.vue?vue&type=template&id=ff1f03f6&"
import script from "./RememberSection.vue?vue&type=script&lang=ts&"
export * from "./RememberSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports